import React from 'react'
import styles from './loading-screen.styles'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone'

const Cell = ({ children, style }) => (
  <td
    style={{
      textAlign: 'center',
      padding: '20px 10px',
      borderBottom: '1px solid #ececec',
      ...style
    }}>
    {children}
  </td>
)
const UserRow = ({ nameWidth }) => (
  <tr>
    <Cell>
      <Bone style={{ width: '20px', height: '20px', borderRadius: '4px' }} />
    </Cell>
    <Cell style={{ textAlign: 'left' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Bone
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '32px',
            marginRight: '10px'
          }}
        />
        <Bone style={{ width: nameWidth, height: '14px' }} />
      </div>
    </Cell>
    <Cell style={{ textAlign: 'left' }}>
      <Bone style={{ width: '80px' }} />
    </Cell>
    <Cell>
      <Bone style={{ width: '82px', height: '31px', borderRadius: '4px' }} />
    </Cell>
    <Cell>
      <Bone style={{ width: '40px' }} />
    </Cell>
    <Cell>
      <Bone style={{ width: '30px', height: '30px', borderRadius: '30px' }} />
    </Cell>
    <Cell style={{ textAlign: 'right' }}>
      <Bone style={{ width: '30px' }} />
    </Cell>
    <Cell>
      <Bone style={{ width: '60px' }} />
    </Cell>
    <Cell style={{ textAlign: 'right' }}>
      <Bone style={{ width: '40px', height: '40px', borderRadius: '5px' }} />
    </Cell>
  </tr>
)

const LoadingScreen = ({ classes }) => (
  <div className={classes.container}>
    <Bone style={{ width: '80px', height: '14px' }} />
    <div
      style={{
        width: '100%',
        marginTop: '20px',
        display: 'flex',
        marginBottom: '16px'
      }}>
      <Bone style={{ height: '40px', flex: '1', borderRadius: '4px' }} />
      <Bone
        style={{
          height: '40px',
          width: '112px',
          borderRadius: '4px',
          marginLeft: '34px'
        }}
      />
    </div>
    <table>
      <tbody>
        <tr>
          <Cell>
            <Bone style={{ width: '30px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '60px' }} />
          </Cell>
          <Cell style={{ textAlign: 'left' }}>
            <Bone style={{ width: '100px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '55px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '55px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '70px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '60px' }} />
          </Cell>
          <Cell>
            <Bone style={{ width: '70px' }} />
          </Cell>
          <Cell />
        </tr>
        <UserRow nameWidth="120px" />
        <UserRow nameWidth="130px" />
        <UserRow nameWidth="70px" />
        <UserRow nameWidth="90px" />
        <UserRow nameWidth="100px" />
        <UserRow nameWidth="80px" />
      </tbody>
    </table>
  </div>
)

export default injectSheet(styles)(LoadingScreen)
